import basePath from "base_path";
import requestor from "requestor";
import type {AmendmentErrorEntry} from "common_components/issue_detail/panels/components/amendments/amendment_group";

interface LogAmendmentFailuresArgs {
  organisationId: number;
  projectId: number;
  documentId: number;
  errors: AmendmentErrorEntry[];
  documentIssueId?: number;
}

export default function logAmendmentFailures({
  organisationId,
  projectId,
  documentId,
  errors,
  documentIssueId,
}: LogAmendmentFailuresArgs) {
  return requestor
    .post(
      `${basePath}/organisation/${organisationId}/project/${projectId}/document/${documentId}/amendment/failures`,
      {document_issue_id: documentIssueId, failures: errors},
      {withCredentials: true},
    )
    .then(response => response.data)
    .catch(err => err.data);
}
